{
  "agb-dialog": {
    "text": {
      "agb": "Điều khoản chung"
    },
    "buttons": {
      "close": "Đóng"
    }
  }
}
